import { KeyRound, Power, PowerOff } from "lucide-react";
import { ROLE_LABELS } from "../../context/AuthContext";
import { slug } from "../../lib/format";

const StatusBadge = ({ active, testId }) => (
  <span
    className={`inline-flex rounded-full px-2.5 py-1 text-xs font-bold ${active ? "bg-[rgba(19,182,122,0.12)] text-[#0f8b5f]" : "bg-[#eef1f6] text-[#5b667a]"}`}
    data-testid={testId}
  >
    {active ? "Activo" : "Desactivado"}
  </span>
);

const UserActions = ({ u, id, onToggle, onReset }) => (
  <div className="flex flex-wrap gap-1.5">
    <button type="button" onClick={() => onToggle(u)} className={`${u.active ? "tr-btn-danger" : "tr-btn-light"} px-2.5 py-1.5 text-xs`} data-testid={`user-toggle-${id}`}>
      {u.active ? <PowerOff className="h-3.5 w-3.5" /> : <Power className="h-3.5 w-3.5" />}
      {u.active ? "Desactivar" : "Reactivar"}
    </button>
    <button type="button" onClick={() => onReset(u)} className="tr-btn-light px-2.5 py-1.5 text-xs" data-testid={`user-reset-${id}`}>
      <KeyRound className="h-3.5 w-3.5" /> Restablecer contraseña
    </button>
  </div>
);

const RoleSelect = ({ u, id, onRole }) => (
  <select value={u.role} onChange={(e) => onRole(u, e.target.value)} className="tr-input h-9 w-auto min-w-[150px] py-0" data-testid={`user-role-${id}`} aria-label={`Rol de ${u.name}`}>
    {Object.entries(ROLE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
  </select>
);

export const UsersTable = ({ users, currentId, onToggle, onReset, onRole }) => (
  <ul className="divide-y divide-[#eef2f7]" data-testid="users-list">
    {users.map((u) => {
      const id = slug(u.email);
      return (
        <li key={u.id} className="flex flex-col gap-3 px-4 py-4 sm:px-5 lg:flex-row lg:items-center" data-testid={`user-row-${id}`}>
          <div className="min-w-0 lg:w-[34%]">
            <div className="flex items-center gap-2 font-bold text-[#182235]" data-testid={`user-name-${id}`}>
              {u.name}
              {u.id === currentId && <span className="rounded-full bg-[#eef4ff] px-2 py-0.5 text-[11px] font-bold text-[#0a47be]">Tú</span>}
            </div>
            <div className="truncate text-sm text-[#5b667a]" data-testid={`user-email-${id}`}>{u.email}</div>
          </div>
          <div className="flex flex-wrap items-center gap-3 lg:w-[30%]">
            <RoleSelect u={u} id={id} onRole={onRole} />
            <StatusBadge active={u.active} testId={`user-status-${id}`} />
            <span className="sr-only" data-testid={`user-role-label-${id}`}>{ROLE_LABELS[u.role]}</span>
          </div>
          <div className="lg:ml-auto">
            <UserActions u={u} id={id} onToggle={onToggle} onReset={onReset} />
          </div>
        </li>
      );
    })}
  </ul>
);
